import { Col, Row } from "react-bootstrap-v5";
import { MInput } from "../../../components/MInput/MInput";
import { useEffect, useState } from "react";
import { API_URL } from "../../../components/MConfig";
import { fire, getPermissao, verificarPermissaoPorPerfilDoUsuario } from "../../../../util";
import { Filtro } from "../Partial/Filtro";
import { tipoPerfil } from "../tipos/tipos";
import axios from "axios";

const asArray = (v) => (Array.isArray(v) ? v : []);

export const FiltroPropostas = (props) => {
    const [statusOptions, setStatusOptions] = useState([]);
    const [produtoIdFiltro, setProdutoId] = useState("");       // manter como string
    const [produtoIdselecionado, setProdutoSelecionadoId] = useState(""); // string
    const [statusOptionsKompMedicamentos, setStatusOptionsKompMedicamentos] = useState([]);
    const [statusOptionsAASPA, setStatusOptionsAASPA] = useState([]);
    const [statusOptionsKompPadrao, setStatusOptionsKompPadrao] = useState([]);
    const [statusOptionsKomaer, setStatusOptionsKompKomaer] = useState([]);
    const [statusOptionsUnaRH, setStatusOptionsKompUnaRH] = useState([]);
    const [statusAdicionalOptions, setStatusAdicionalOptions] = useState([]);

    // Busca status por produto, com guarda
    const buscarStatus = async (produtoId) => {
        if (!produtoId) {
            setStatusOptions([]);
            return;
        }
        try {
            const { data } = await axios.get(`${API_URL}/proposta/ListarStatusPorProdutoId/${produtoId}`);
            const options = asArray(data).map((z) => ({ value: z.id, text: z.nome }));

            if (produtoId === "8") setStatusOptionsKompMedicamentos(options);
            else if (produtoId === "6") setStatusOptionsAASPA(options);
            else if (produtoId === "1" || produtoId === "3" || produtoId === "5") setStatusOptionsKompPadrao(options);
            else if (produtoId === "11") setStatusOptionsKompKomaer(options);
            else if (produtoId === "7") setStatusOptionsKompUnaRH(options);
        } catch (error) {
            console.error("Erro ao buscar os status:", error);
        }
    };

    const buscarStatusAdicional = async () => {
        try {
            const { data } = await axios.get(`${API_URL}/proposta/ListarStatusAdicionaisPropostaGovBr`);
            const options = asArray(data).map((z) => ({ value: z.id, text: z.descricao }));
            setStatusAdicionalOptions(options);
        } catch (error) {
            console.error("Erro ao buscar os status adicional:", error);
        }
    };

    // Handler que aceita onChange(event) OU onClick(event) ou até valor direto
    const handleProdutoChange = (evOrVal) => {
        const selectedValue =
            typeof evOrVal === "string" || typeof evOrVal === "number"
                ? String(evOrVal)
                : evOrVal?.target?.value
                    ? String(evOrVal.target.value)
                    : "";

        setProdutoId(selectedValue);
        setProdutoSelecionadoId(selectedValue);

        if (selectedValue === "1" || selectedValue === "3" || selectedValue === "5") {
            setStatusOptions(asArray(statusOptionsKompPadrao));
        } else if (selectedValue === "11") {
            setStatusOptions(asArray(statusOptionsKomaer));
        } else if (selectedValue === "7") {
            setStatusOptions(asArray(statusOptionsUnaRH));
        } else if (selectedValue === "8") {
            setStatusOptions(asArray(statusOptionsKompMedicamentos));
        } else if (selectedValue === "6") {
            setStatusOptions(asArray(statusOptionsAASPA));
            // já carregado em buscarStatusAdicional(); aqui só garantimos que existe array
            setStatusAdicionalOptions(asArray(statusAdicionalOptions));
        } else if (selectedValue === "14" || selectedValue === "15" || selectedValue === "16" || selectedValue === "17") {
            setStatusOptions(asArray(statusOptionsKompPadrao));
        } else {
            setStatusOptions([]);
        }
    };

    useEffect(() => {
        // carrega todas as listas necessárias uma vez
        ["6", "8", "1", "2", "3", "11", "7"].forEach(buscarStatus);
        buscarStatusAdicional();
    }, []);

    // GUARDA principal: nunca mandar undefined para MInput.data nem usar res.map sem checar
    const produtosData = asArray(props.produtos);

    return (
        <Filtro
            novo={props.novo}
            ocultarNovo={false}
            chamada="filtrar_proposta"
            urlDownload="/proposta/DownloadRelatorio"
        >
            <Row>
                <Col className="col-md-6 col-12">
                    <MInput id="termoDaBusca" type="text" title="Nome ou CPF" />
                </Col>

                <Col className="col-md-3">
                    <MInput type="date" id="DataCadastroInicio" title="Periodo Inicio" />
                </Col>

                <Col className="col-md-3">
                    <MInput id="DataCadastroFim" type="date" title="Periodo" />
                </Col>

                <Col className="col-md-4">
                    <MInput
                        id="produtoId"
                        type="select"
                        title="Produto"
                        data={produtosData}                           // nunca undefined
                        default="Todos"
                        onResult={(res) => asArray(res).map((z) => ({ value: z.id, text: z.nome }))} // res seguro
                        onChange={handleProdutoChange}               // preferível
                        onClick={handleProdutoChange}                // compatibilidade com seu MInput
                    />
                </Col>

                {produtoIdFiltro && (
                    <Col className="col-md-4 col-12">
                        <MInput
                            id="statusId"
                            type="selectCheckbox"
                            title="Status"
                            data={asArray(statusOptions)}              // garante array
                            default="Todos"
                        />
                    </Col>
                )}

                {produtoIdselecionado === "6" && (
                    <Col className="col-md-4 col-12">
                        <MInput
                            id="statusAdicionalId"
                            type="selectCheckbox"
                            title="Status Adicional"
                            data={asArray(statusAdicionalOptions)}     // garante array
                            default="Todos"
                        />
                    </Col>
                )}

                {verificarPermissaoPorPerfilDoUsuario() && (
                    <Col className="col-md-4 col-12">
                        <MInput
                            id="revendedorId"
                            type="selectSearch"
                            title="Empresa"
                            placeholder="Digite o nome da empresa..."
                            url={`${API_URL}/revendedor/ListarRevendedores`}
                            params={(v) => ({ TermoDaBusca: v ?? "" })}
                            onResult={(res) => asArray(res?.resultado).map((z) => ({ value: z.id, text: z.nome }))}
                        />
                    </Col>
                )}

                {!getPermissao(null, tipoPerfil.Vendedor) && (
                    <Col className="col-md-4 col-12">
                        <MInput
                            id="usuarioId"
                            type="selectSearch"
                            title="Usuario"
                            placeholder="Digite o nome do usuario..."
                            url={`${API_URL}/Usuario/ListarUsuarios`}
                            params={(v) => ({ TermoDaBusca: v ?? "" })}
                            onResult={(res) => asArray(res?.resultado).map((z) => ({ value: z.id, text: z.nome }))}
                        />
                    </Col>
                )}
            </Row>
        </Filtro>
    );
};
